import angular from 'angular';

const meetingsServices = angular.module('applicationModule.meetingsServices', []);


meetingsServices.factory('Meeting', ['MeetingAPI', function (MeetingAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return MeetingAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (meetingId, appId) {
            return MeetingAPI.getMeeting(meetingId, appId);
        },
        save: function (meeting, editMode) {
            if (editMode) {
                return MeetingAPI.editMeeting(meeting);
            } else {
                return MeetingAPI.createMeeting(meeting);
            }
        },
        remove: function (meetingId) {
            return MeetingAPI.removeMeeting(meetingId);
        },
        getBeacons: function () {
            return MeetingAPI.getBeacons();
        },
        downloadReport: function (appId, end_date, start_date) {
            return MeetingAPI.downloadReport(appId, end_date, start_date);
        }
    };
}]);

meetingsServices.service('MeetingAPI', ['$http', '$filter', 'AppsoupAPI', function ($http, $filter, AppsoupAPI) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/meeting/';

    this.getBeacons = function () {
        return $http.get(API_URL + 'beacons/get');
    };

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getMeeting = function (meetingId, appId) {
        return $http.get(API_URL + meetingId, {params: {application_id: appId}});
    };

    this.createMeeting = function (meeting) {
        return $http.post(API_URL, meeting);
    };

    this.editMeeting = function (meeting) {
        return $http.put(API_URL + meeting.id, meeting);
    };

    this.removeMeeting = function (meetingId) {
        return $http.delete(API_URL + meetingId);
    };

    this.downloadReport = function (appId, end_date, start_date) {
        return $http.get(API_URL + 'report/generate', {
            params: {
                application_id: appId,
                end_date: end_date,
                start_date: start_date
            }
        });
    };

}]);

export default meetingsServices;
